import React from 'react'

const NotFoundPage = () => {
  return (
    <section className='not-found-page-section'>
        404
    </section>
  )
}

export default NotFoundPage